module.exports = __webpack_public_path__ + "static/LOGO 10-62cfda31480c2ac659d0d87cc656a9c6.png";